import React from 'react';

import cx from 'classnames';

import { FormattedMessage } from 'react-intl';
import { Headline, BodyCopy } from '@xingternal/typography';

import { Button } from '@xingternal/button';

import { getMarketingPageUrl } from '../../common/components/Upsell/utils';

import styles from './News.css';

type NewsPremiumBannerProps = {
 buttonTextKey?: string;
  className?: string;
  flagTextKey?: string;
  focusType?: string;
  headlineCopyKey: string;
  href?: string;
  locale: string;
  moduleName: string;
  testId?: string;
  textCopyKey: string;
};

const NewsPremiumBanner = ({
  buttonTextKey,
  className,
  flagTextKey,
  focusType,
  headlineCopyKey,
  href,
  locale,
  moduleName,
  testId,
  textCopyKey,
}: NewsPremiumBannerProps) => {
  if (href && href.length) {
    href = getMarketingPageUrl({
      locale,
      focusType,
      moduleName,
      component: 'teaser',
    });
  }

  return (
    <div className={cx(styles.premiumWrapper, className)} data-testid={testId}>
      <div className={styles.textWrapper}>
        {flagTextKey && (
          <span className={styles.flag}>
            <FormattedMessage id={flagTextKey} defaultMessage={flagTextKey} />
          </span>
        )}
        <Headline size={'large'} className={styles.headerText}>
          <FormattedMessage id={headlineCopyKey} defaultMessage={headlineCopyKey} />
        </Headline>
        <BodyCopy noMargin size={'small'} className={styles.text}>
          <FormattedMessage id={textCopyKey} defaultMessage={textCopyKey} />
        </BodyCopy>
      </div>
      {href && (
        <Button
          className={styles.premiumButton}
          href={href}
          rel="noreferrer noopener nofollow"
          size={'medium'}
          target="_blank"
          variant="proBusiness"
        >
          <FormattedMessage id={buttonTextKey} defaultMessage={buttonTextKey} />
        </Button>
      )}
    </div>
  );
};

export default NewsPremiumBanner;
